import { Box, Text } from '@factorialco/deprecated-design-system'
import { A3IncidenceFinanceCostCenterMembershipFragment } from 'generated/resources/graphql'

import DetailLine from '../_DetailLine'

const parsePercentage = (percentage: number) => {
  return `${(percentage * 100).toFixed(0)}%`
}

interface Props {
  title: string
  costCenters: A3IncidenceFinanceCostCenterMembershipFragment[]
}

export const CostCentersHiringDetails = ({ title, costCenters }: Props) => {
  return (
    <Box gap="s8" paddingBottom="s24">
      <Text.Normal size="200" color="grey800" weight="bold">
        {title}
      </Text.Normal>

      <Box gap="s2" component="ul" paddingLeft="s16" style={{ listStyle: 'disc' }}>
        {costCenters.map((costCenter) => (
          <DetailLine
            key={costCenter.costCenter.name}
            component="li"
            title={costCenter.costCenter.name}
            value={parsePercentage(costCenter.percentage)}
            style={{ display: 'list-item' }}
          />
        ))}
      </Box>
    </Box>
  )
}
